import { render, staticRenderFns } from "./testInputForm.vue?vue&type=template&id=5ac8a82a&"
import script from "./testInputForm.vue?vue&type=script&lang=js&"
export * from "./testInputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports